const CALLBACK_ORIGIN = "https://callback.invalid"

function repeatedlyDecode(value: string): string | undefined {
  let decoded = value
  try {
    for (let iteration = 0; iteration < 64; iteration += 1) {
      const escapedBarePercents = decoded.replace(/%(?![0-9a-f]{2})/gi, "%25")
      const next = decodeURIComponent(escapedBarePercents)
      if (next === decoded) return decoded
      decoded = next
    }
    return undefined
  } catch {
    return undefined
  }
}

export function normalizeCallbackPath(value: string | null | undefined): string | undefined {
  if (!value || !value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u001f\u007f]/.test(value)) {
    return undefined
  }

  const decoded = repeatedlyDecode(value)
  if (!decoded || decoded.startsWith("//")) {
    return undefined
  }
  const decodedPath = decoded.split(/[?#]/, 1)[0]
  if (decodedPath.includes("\\") || decodedPath.split("/").some(segment => segment === "..")) {
    return undefined
  }

  try {
    const parsed = new URL(value, CALLBACK_ORIGIN)
    if (parsed.origin !== CALLBACK_ORIGIN) return undefined
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return undefined
  }
}

export function resolveAuthRedirectUrl(url: string, baseUrl: string): string {
  let base: URL
  try {
    base = new URL(baseUrl)
    const parsed = new URL(url, base)
    if (parsed.origin !== base.origin) return baseUrl

    const callbackPath = normalizeCallbackPath(`${parsed.pathname}${parsed.search}${parsed.hash}`)
    return callbackPath ? new URL(callbackPath, base).toString() : baseUrl
  } catch {
    return baseUrl
  }
}
